import { Navigate, Route, Routes } from 'react-router-dom';
import { ChartReaderPageRoutes } from './ChartReader';

export function ChartReaderRoutes() {
    return (
        <Routes>
            <Route path='/*' element={<Navigate to='.' replace />} />
            <Route path='/' element={<ChartReaderPageRoutes />} />
        </Routes>
    );
}
